export const AGGREGATOR_PROCESS_LIST_ENTITY_NAME = 'AggregatorProcessList';
